export default __webpack_public_path__ + "src/images/packages/monte-vista-boutique-hotel/1e83f38e229bd78bb0288241113dba01-1.jpg";